import StatisticsDashboard from './StatisticsDashboard';

/**
 * Estadísticas de atención (gestión): el tablero de todo el sitio, con el filtro Profesional para quien puede ver a
 * todos. El tablero es `StatisticsDashboard`, el mismo de «Mi desempeño».
 */
export default function ServicesStatisticsView() {
    return <StatisticsDashboard mode="management" />;
}
